// import 'promise-polyfill';
// import 'isomorphic-fetch';

let NextInLine = require('./widget');
function init() {
	let hashes = location.search.slice(location.search.indexOf('?') + 1).split('&');
	let params = {};


    hashes.map(hash => {
        let [key, val] = hash.split('=');
        params[key] = decodeURIComponent(val);
    })
	
	if(module.hot){
		NextInLine = require('./widget');
	}
	
	window.NextInLine = NextInLine;
	
	
	if(window.nsaiframe){
		const widget = document.querySelector('#widget');
		window.nextInLine = NextInLine.init({
			...params,
			demoMode: true,
			organizationID: params.organizationID,
			displayOrganizationName: true,
			cost: 60

		})
		window.nextInLine.render(widget);
	}	
}

// // register ServiceWorker via OfflinePlugin, for prod only:
// if (process.env.NODE_ENV==='production') {
// 	require('./pwa');
// }

// in development, set up HMR:
if (module.hot) {
	//require('preact/devtools');   // turn this on if you want to enable React DevTools!
	module.hot.accept('./widget', () => requestAnimationFrame(init) );
}

init();



// WEBPACK FOOTER //
// ./index.js